import { render, staticRenderFns } from "./SocialDataSidebar.vue?vue&type=template&id=13a2054a&scoped=true&"
import script from "./SocialDataSidebar.vue?vue&type=script&lang=js&"
export * from "./SocialDataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SocialDataSidebar.vue?vue&type=style&index=0&id=13a2054a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2054a",
  null
  
)

export default component.exports